import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch complaints
export const fetchComplaints = createAsyncThunk(
  "complaints/fetchComplaints",
  async (page = 1, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(`${BASE_URL}/dashboard/complaint?page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل في جلب الشكاوى"
      );
    }
  }
);

// Fetch single complaint
export const fetchComplaint = createAsyncThunk(
  "complaints/fetchComplaint",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(`${BASE_URL}/dashboard/complaint/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل في جلب الشكوى"
      );
    }
  }
);

// Delete complaint
export const deleteComplaint = createAsyncThunk(
  "complaints/deleteComplaint",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.delete(`${BASE_URL}/dashboard/complaint/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل في حذف الشكوى"
      );
    }
  }
);

const initialState = {
  data: [],
  pagination: {
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
    has_more_pages: false,
    next_page_url: null,
    prev_page_url: null,
  },
  loading: false,
  error: null,
  deleteLoading: false,
  deleteError: null,
  deleteSuccessMessage: null,
  currentComplaint: null,
  isLoading: false,
};

const complaintSlice = createSlice({
  name: "complaints",
  initialState,
  reducers: {
    clearComplaintState: (state) => {
      state.error = null;
      state.deleteError = null;
      state.deleteSuccessMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch complaints
      .addCase(fetchComplaints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete complaint
      .addCase(deleteComplaint.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
      })
      .addCase(deleteComplaint.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccessMessage = action.payload.message || "تم حذف الشكوى بنجاح";
      })
      .addCase(deleteComplaint.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
      })
      .addCase(fetchComplaint.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchComplaint.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentComplaint = action.payload.data;
        state.error = null;
      })
      .addCase(fetchComplaint.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.currentComplaint = null;
      });
  },
});

export const { clearComplaintState } = complaintSlice.actions;
export default complaintSlice.reducer;